import React from 'react';
import { Text, FontIcon, FontSizes, IProgressIndicatorStyles, ProgressIndicator } from '@fluentui/react';
import { BwjSpinner } from '../bwj-spinner';
import { useBillboardStyles } from './styles';
import { BwjButton, IBwjButtonProps } from '../bwj-button';
import { IBwjGraphicComponentProps } from '../../entities/bwj-graphic-component';

export interface IBwjBillboardProps {
  icon?: string;
  graphic?: React.FunctionComponent<IBwjGraphicComponentProps>;
  graphicPortraitOriented?: boolean;
  message?: string;
  progress?: number;
  buttons?: IBwjButtonProps[];
}

const progressStyles: Partial<IProgressIndicatorStyles> = {
  root: {
    width: '90%',
    maxWidth: 1200,
    marginTop: FontSizes.xxLarge,
  },
};

const landscapeGraphicProps: IBwjGraphicComponentProps = {
  style: {
    display: 'block',
    width: '85%',
    maxWidth: 750,
  },
};
const portraitGraphicProps: IBwjGraphicComponentProps = {
  style: {
    display: 'block',
    height: '40vh',
    maxHeight: 500,
  },
};

export const BwjBillboard: React.FunctionComponent<IBwjBillboardProps> = (props) => {
  const styles = useBillboardStyles();
  const graphicProps = props.graphicPortraitOriented === true ? portraitGraphicProps : landscapeGraphicProps;

  return (
    <div className={styles.billboard}>
      {props.icon === 'spinner' ? <BwjSpinner size={FontSizes.mega} /> :
      !!props.icon ? <FontIcon iconName={props.icon} style={{fontSize: FontSizes.mega}} /> : null}
      {!!props.graphic && props.graphic(graphicProps)}

      {!!props.message &&
      <Text variant="xLarge" className={styles.message}>
        {props.message}
      </Text>}

      {props.progress !== undefined &&
      <ProgressIndicator barHeight={5} styles={progressStyles} percentComplete={(props.progress / 100)} />}

      {!!props.buttons && 
      <div className={styles.buttonContainer}>
        {props.buttons.map(button => <BwjButton key={button.text} {...button} />)}
      </div>}
    </div>
  );
};
